module.exports = __webpack_public_path__ + "uzbekistan.svg?d68b06bd648678ccb7fed1f202325ac1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/uzbekistan.svg
// module id = 335
// module chunks = 10